export { default } from './BigQuestionText'
